//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 760px) {
        min-width: ${({ minWidth = "400px" }) => minWidth};
    }
    width: 100%;
    gap: ${({ gap = "35px" }) => gap};
`;
export const Content = styled.article`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: ${({ width = "80%" }) => width};
    gap: ${({ gap = "6px" }) => gap};
    & img {
        width: 50%;
    }
    &.content-component img {
        width: 240px;
    }
    & > h3 {
        color: var(--purple-6);
        &.secondary {
            color: var(--dark-4);
        }
        font-weight: 900;
        font-size: 22px;
        text-align: center;
        margin: 12px 0;
        margin-top: 25px;
    }
    &:not(.content-component) > p { margin: 0; }
    & .paragraph {
        color: var(--light-gray-5);
        font-size: 14px;
        margin: 0;
        list-style: none;
        &.center {
            text-align: center;
            width: 100%;
        }
    }
    & .list {
        font-size: 14px;
        line-height: 20px;
        width: max-content;
        padding: 0;
        margin: 0;
    }
`;
export const Footer = styled.footer`
    display: flex;
    gap: 15px;
`;